import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import DeleteAction from 'core/actions/DeleteAction'
import ListAction from 'core/actions/ListAction'
import UpdateAction from 'core/actions/UpdateAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

const { kubernetes } = ApiClient.getInstance()

export const kaapiMachineActions = ActionsSet.make<DataKeys.KaapiMachines>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiMachines],
  cacheKey: DataKeys.KaapiMachines,
})

export const deleteKaapiMachines = kaapiMachineActions.add(
  new DeleteAction<DataKeys.KaapiMachines, { namespace: string; name: string }>(
    async ({ namespace, name }) => {
      Bugsnag.leaveBreadcrumb('Attempting to delete Kaapi Machines', { namespace, name })
      await kubernetes.deleteCustomResource({ type: DataKeys.KaapiMachines, name })
    },
  ),
)

export const listKaapiMachines = kaapiMachineActions.add(
  new ListAction<DataKeys.KaapiMachines>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to get Kaapi Machines ', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiMachines)
  })
    .addDependency(DataKeys.KaapiMachineDeployments)
    .addDependency(DataKeys.KaapiNodes)
    .addDependency(DataKeys.KaapiMetricsNodes),
)

export const updateKaapiMachine = kaapiMachineActions.add(
  new UpdateAction<
    DataKeys.KaapiMachines,
    { namespace: string; name: string; customBody: any; contentType: string }
  >(async ({ namespace, name, customBody, contentType }) => {
    Bugsnag.leaveBreadcrumb('Attempting to update Kaapi Machine', { namespace, name })
    await kubernetes.patchCustomResource({
      type: DataKeys.KaapiMachines,
      name,
      body: customBody,
      contentType,
    })
  }),
)

export const kaapiMachineActionsAllClusters = ActionsSet.make<DataKeys.KaapiMachines>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiMachines],
  cacheKey: DataKeys.KaapiMachines,
})

export const listKaapiMachineAllClusters = kaapiMachineActionsAllClusters.add(
  new ListAction<DataKeys.KaapiMachines>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to get Kaapi Machines ', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiMachines)
  })
    .addDependency(DataKeys.KaapiMachineDeployments)
    .addDependency(DataKeys.KaapiNodesAllClusters),
)
